import { env } from '@env/.env';

const providersUrl = 'https://providers.ncpehcy.eu';
const beneficiariesUrl = 'https://portal.ncpehcy.eu';

const url = window.location.hostname;

export const environment = {
  ...{
    name: 'development',
    production: false,
    app_url: url.startsWith('providers') ? providersUrl : beneficiariesUrl,
    bff_url: url.startsWith('providers') ? providersUrl : beneficiariesUrl,
    paths: {
      api: '/api',
      bff: '/bff',
    },
  },
  ...env,
};
